<template>
    <div class="col-sm-3 mb-5 mb-xl-10" >
      <div class="card card-flush h-lg-100">
        <div class="card-header pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bolder text-dark">{{$t('setting.setting_systeme')}}</span>
            <span class="text-gray-400 mt-1 fw-bold fs-6"></span>
          </h3>
        </div>
        <div class="card-body pt-5">
          <router-link :to="'settings-system/system'" v-if="$can(abilities.EMAIL_MESSAGE_VIEW)" >
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.system')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'settings-system/smtp'" v-if="$can(abilities.EMAIL_CONFIG_VIEW)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.smtp')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
           <router-link :to="'settings-system/twilio'" v-if="$can(abilities.EMAIL_CONFIG_VIEW)"> 
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.twilio')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>

          <router-link :to="'settings-system/reminder'" v-if="$can(abilities.REMIND_CONFIG_VIEW) && $canAccess(moduleAbilities.CRM_INVOICE)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.reminder_config')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'settings-system/template'" v-if="$can(abilities.TEMPLATE_CONFIG_VIEW) && $canAccess(moduleAbilities.GENERAL_INVOICE)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.template_config')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'settings-system/payment'" v-if="$can(abilities.VIEW_PAYMENT_TYPE) && $canAccess(moduleAbilities.CRM_INVOICE)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.payment_mode')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'settings-system/paymentCondition'" v-if="$can(abilities.VIEW_PAYMENT_CONDITION) && $canAccess(moduleAbilities.CRM_INVOICE)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.payment_condition')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'mail/settings-system/imap'" v-if="$can(abilities.EMAIL_CONFIG_VIEW) && $canAccess(moduleAbilities.COMMUNICATION_MAIL)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('setting.imap')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import abilities from "@/composables/abilities";
  import moduleAbilities from "@/composables/moduleAbilities";

  </script>
  <style scoped>
  
  </style>
  